<template>
  <div v-if="storage" class="wwLoader" :class="{ 'wwLoader--contain': contain }">
    <div class="wwLoader__stage">
      <span class="wwLoader__ring"></span>
      <img class="wwLoader__mark" :src="faviconSrc" alt="" aria-hidden="true" />
    </div>
    <span class="wwLoader__text">Loading</span>
  </div>
</template>

<script>
export default {
  // Same props as before, so none of the ~200 call sites need changing.
  props: ["storage", "contain"],
  computed: {
    // The favicon linked from public/index.html, resolved through the app's
    // public path so it works under a sub-directory deploy too.
    faviconSrc() {
      return (process.env.BASE_URL || "/") + "fav.ico";
    },
  },
};
</script>

<style scoped>
.wwLoader {
  position: fixed;
  inset: 0;
  z-index: 2400;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(2px);
}

/* Used when the loader should cover only its own panel. */
.wwLoader--contain {
  position: absolute;
  z-index: 6;
  background: rgba(255, 255, 255, 0.8);
}

.wwLoader__stage {
  position: relative;
  width: 74px;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wwLoader__ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid #e4efe7;
  border-top-color: #2e6b3f;
  animation: wwLoaderSpin 0.9s linear infinite;
}

.wwLoader__mark {
  width: 36px;
  height: 36px;
  object-fit: contain;
  animation: wwLoaderPulse 1.5s ease-in-out infinite;
}

.wwLoader__text {
  font-family: sofiaProMedium, "Poppins", sans-serif;
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #5f7d6b;
}

@keyframes wwLoaderSpin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes wwLoaderPulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.09);
    opacity: 0.78;
  }
}

/* Keep it usable for anyone who has asked the OS to reduce motion. */
@media (prefers-reduced-motion: reduce) {
  .wwLoader__ring {
    animation-duration: 2.4s;
  }
  .wwLoader__mark {
    animation: none;
  }
}
</style>
